export const DEPTH_MODULE = 566
export const WIDTH_MIN_MODULE = 500
export const WIDTH_MAX_MODULE = 1000
export const WIDTH_ANGLE_MODULE = 854
export const WIDTH_ANGLES_MODULE = 1708



// WEBPACK FOOTER //
// ./resources/js/resource/ModuleParams.js